import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthServiceService } from '../services/AuthService.service';
import { WebUserDetails } from '../../shared/models/WebUserDetails';
import { WebUserService } from '../services/WebUser.service';

@Injectable()
export class AuthguardGuard implements CanActivate {
  CurrentUser: WebUserDetails;
  Allusers: WebUserDetails[];
  constructor(private router: Router, private _service: AuthServiceService, private webSer: WebUserService) {
    this.Allusers = JSON.parse(localStorage.getItem('userDetails'));
    if (this.Allusers != undefined && this.Allusers != null) {
      // tslint:disable-next-line: triple-equals
      this.CurrentUser = this.Allusers.filter(i => i.id == JSON.parse(sessionStorage.getItem('Id')))[0];
    }
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {

    this.Allusers = JSON.parse(localStorage.getItem('userDetails'));
    if (sessionStorage.getItem('Id') != null && sessionStorage.getItem('Id') != undefined && this.Allusers != undefined && this.Allusers!=null) {
      let roles = next.data["roles"] as Array<string>;
      if (roles) {
        var match = this._service.roleMatch(roles);
        if (match) return true;
        else {
          this.router.navigate(['/notFound']);
          return false;
        }
      }
      return true;
    }
    else {
      localStorage.clear();
      alert('Redirecting to login,Please refresh the LOGIN page manually before use!');
      this.router.navigate(['/login']);
      return false;
    }
  }
}
